import DropdownComponent from './dropdown-component.js';

/**
 * Custom variant selector web component that replaces standard select elements
 * Inherits dropdown functionality from DropdownComponent and adds variant-specific logic
 * 
 * @template {import('@theme/component').Refs} [Refs = {}]
 * @extends DropdownComponent<Refs>
 */
export default class VariantSelector extends DropdownComponent {
  /** @type {string[]} */
  requiredRefs = ['trigger', 'dropdown', 'valueDisplay', 'options'];

  connectedCallback() {
    super.connectedCallback();
    
  }

  /**
   * Called when an option is selected - handles variant change logic
   * @param {HTMLElement} option
   */
  onOptionSelected(option) {
    this.dispatchChangeEvent(option);
  }

  /**
   * Dispatches a change event to maintain compatibility with variant picker
   * @param {HTMLElement} option
   */
  dispatchChangeEvent(option) {
    const syntheticEvent = new CustomEvent('change', {
      bubbles: true,
      detail: {
        target: {
          value: option.dataset.value,
          dataset: option.dataset,
          selectedIndex: this.refs.options && Array.isArray(this.refs.options) ? this.refs.options.indexOf(option) : 0
        }
      }
    });

    const variantPicker = this.closest('variant-picker');
    if (variantPicker && variantPicker instanceof HTMLElement) {
      variantPicker.dispatchEvent(syntheticEvent);
    }
  }
}

if (!customElements.get('variant-selector')) {
  customElements.define('variant-selector', VariantSelector);
}